export enum TranslationsKeys {
  common_search = 'common_search',
  common_surveyStatus_completed = 'common_surveyStatus_completed',
  common_surveyStatus_inProgress = 'common_surveyStatus_inProgress',
  common_surveyStatus_draft = 'common_surveyStatus_draft',
  common_surveyStatus_notStarted = 'common_surveyStatus_notStarted',
  common_surveyStatus_skipped = 'common_surveyStatus_skipped',
  common_customer = 'common_customer',
  common_country = 'common_country',
  common_address = 'common_address',
  common_sector = 'common_sector',
  common_business = 'common_business',
  common_businessArea = 'common_businessArea',
  common_plannedVisit = 'common_plannedVisit',
  common_contact = 'common_contact',
  common_customerNumberAbbreviated = 'common_customerNumberAbbreviated',
  common_survey = 'common_survey',
  common_cancel = 'common_cancel',
  common_all = 'common_all',
  common_results = 'common_results',
  common_delete = 'common_delete',
  common_close = 'common_close',
  common_yes = 'common_yes',
  common_no = 'common_no',
  common_noCustomer = 'common_noCustomer',
  common_loadingError = 'common_loadingError',
  common_savingError = 'common_savingError',
  common_select = 'common_select',
  common_view = 'common_view',
  common_edit = 'common_edit',
  common_showMore = 'common_showMore',
  common_showLess = 'common_showLess',
  common_filters = 'common_filters',
  common_clearAll = 'common_clearAll',
  common_version = 'common_version',
  common_addNew = 'common_addNew',
  error500_title = 'error500_title',
  error500_text = 'error500_text',
  error500_back = 'error500_back',
  mainNavigationAriaLabel = 'mainNavigationAriaLabel',
  expandNavigationAriaLabel = 'expandNavigationAriaLabel',
  collapseNavigationAriaLabel = 'collapseNavigationAriaLabel',
  expandUserMenuAriaLabel = 'expandUserMenuAriaLabel',
  collapseUserMenuAriaLabel = 'collapseUserMenuAriaLabel',
  authenticationContext_error = 'authenticationContext_error',
  userMenu_online = 'userMenu_online',
  userMenu_offline = 'userMenu_offline',
  userMenu_onlineDescription = 'userMenu_onlineDescription',
  userMenu_offlineDescription = 'userMenu_offlineDescription',
  userMenu_lastOnline = 'userMenu_lastOnline',
  mainNavigationLinksLabel = 'mainNavigationLinksLabel',
  navigationLinks_mySurveys = 'navigationLinks_mySurveys',
  navigationLinks_startNewSurvey = 'navigationLinks_startNewSurvey',
  navigationLinks_logoutUser = 'navigationLinks_logoutUser',
  surveyStepper_step_intro = 'surveyStepper_step_intro',
  surveyStepper_step_survey = 'surveyStepper_step_survey',
  surveyStepper_step_wrapUp = 'surveyStepper_step_wrapUp',
  loginPage_title = 'loginPage_title',
  loginPage_description = 'loginPage_description',
  loginPage_buttonText = 'loginPage_buttonText',
  loginPage_buttonLoadingText = 'loginPage_buttonLoadingText',
  loginPage_offlineErrorTitle = 'loginPage_offlineErrorTitle',
  loginPage_offlineErrorDescription = 'loginPage_offlineErrorDescription',
  mySurveysPage_tabs_plannedVisits = 'mySurveysPage_tabs_plannedVisits',
  mySurveysPage_tabs_inProgressVisits = 'mySurveysPage_tabs_inProgressVisits',
  mySurveysPage_tabs_completedVisits = 'mySurveysPage_tabs_completedVisits',
  mySurveysPage_info_plannedVisits = 'mySurveysPage_info_plannedVisits',
  mySurveysPage_search_filtersToggle = 'mySurveysPage_search_filtersToggle',
  mySurveysPage_search_filters_myUpcomingVisits = 'mySurveysPage_search_filters_myUpcomingVisits',
  mySurveysPage_search_filters_myOpenVisits = 'mySurveysPage_search_filters_myOpenVisits',
  mySurveysPage_search_filters_myVisitsToday = 'mySurveysPage_search_filters_myVisitsToday',
  mySurveysPage_search_filters_myVisitsTomorrow = 'mySurveysPage_search_filters_myVisitsTomorrow',
  mySurveysPage_search_filters_myVisitsThisWeek = 'mySurveysPage_search_filters_myVisitsThisWeek',
  mySurveysPage_search_filters_myVisitsThisMonth = 'mySurveysPage_search_filters_myVisitsThisMonth',
  mySurveysPage_myVisits_title = 'mySurveysPage_myVisits_title',
  mySurveysPage_inProgressVisits_title = 'mySurveysPage_inProgressVisits_title',
  mySurveysPage_completedVisits_title = 'mySurveysPage_completedVisits_title',
  mySurveysPage_noSurveys = 'mySurveysPage_noSurveys',
  mySurveysPage_noSearchResults = 'mySurveysPage_noSearchResults',
  mySurveysPage_newSurveyButtonText = 'mySurveysPage_newSurveyButtonText',
  mySurveysPage_newSurveyWithoutCustomer = 'mySurveysPage_newSurveyWithoutCustomer',
  mySurveysPage_showVisits = 'mySurveysPage_showVisits',
  mySurveysPage_overdue = 'mySurveysPage_overdue',
  mySurveysPage_error = 'mySurveysPage_error',
  surveyIntroPage_title = 'surveyIntroPage_title',
  surveyIntroPage_openCustomerSelectionAriaLabel = 'surveyIntroPage_openCustomerSelectionAriaLabel',
  surveyIntroPage_openSurveyTemplateSelectionAriaLabel = 'surveyIntroPage_openSurveyTemplateSelectionAriaLabel',
  surveyIntroPage_selectCustomerHeading = 'surveyIntroPage_selectCustomerHeading',
  surveyIntroPage_selectCustomerMessageBarTitle = 'surveyIntroPage_selectCustomerMessageBarTitle',
  surveyIntroPage_selectCustomerMessageBarDescription = 'surveyIntroPage_selectCustomerMessageBarDescription',
  surveyIntroPage_selectSurveyTemplateHeading = 'surveyIntroPage_selectSurveyTemplateHeading',
  surveyIntroPage_noCustomerText = 'surveyIntroPage_noCustomerText',
  surveyIntroPage_noCustomerConfirmationTitle = 'surveyIntroPage_noCustomerConfirmationTitle',
  surveyIntroPage_noCustomerConfirmationDescription = 'surveyIntroPage_noCustomerConfirmationDescription',
  surveyIntroPage_noCustomerConfirmationContinueButtonText = 'surveyIntroPage_noCustomerConfirmationContinueButtonText',
  surveyIntroPage_noCustomerConfirmationAddCustomerButtonText = 'surveyIntroPage_noCustomerConfirmationAddCustomerButtonText',
  surveyIntroPage_customerVisit_participants = 'surveyIntroPage_customerVisit_participants',
  surveyIntroPage_customerVisit_visitType = 'surveyIntroPage_customerVisit_visitType',
  surveyPage_loadingError = 'surveyPage_loadingError',
  surveyPage_closeAndContinueLater = 'surveyPage_closeAndContinueLater',
  surveyPage_deleteSurvey = 'surveyPage_deleteSurvey',
  surveyPage_sectionSkipped = 'surveyPage_sectionSkipped',
  surveyPage_continue = 'surveyPage_continue',
  surveyPage_deleteSurveyConfirmTitle = 'surveyPage_deleteSurveyConfirmTitle',
  surveyPage_deleteSurveyConfirmText1 = 'surveyPage_deleteSurveyConfirmText1',
  surveyPage_deleteSurveyConfirmText2 = 'surveyPage_deleteSurveyConfirmText2',
  surveySectionPage_skipSection = 'surveySectionPage_skipSection',
  surveySectionPage_close = 'surveySectionPage_close',
  surveySectionPage_numericInputDescription = 'surveySectionPage_numericInputDescription',
  surveySectionPage_skipSectionTitle = 'surveySectionPage_skipSectionTitle',
  surveySectionPage_skipSectionDescription = 'surveySectionPage_skipSectionDescription',
  surveySectionPage_skipSectionNotRelevant = 'surveySectionPage_skipSectionNotRelevant',
  surveySectionPage_skipSectionNotObserved = 'surveySectionPage_skipSectionNotObserved',
  surveySectionPage_skipSectionOther = 'surveySectionPage_skipSectionOther',
  surveySectionPage_productsInUse = 'surveySectionPage_productsInUse',
  surveySectionPage_addProduct = 'surveySectionPage_addProduct',
  surveySectionPage_updateProduct = 'surveySectionPage_updateProduct',
  surveySectionPage_detailedDescription = 'surveySectionPage_detailedDescription',
  surveySectionPage_deleteProduct = 'surveySectionPage_deleteProduct',
  surveySectionPage_deleteProductConfirm = 'surveySectionPage_deleteProductConfirm',
  surveyWrapUpPage_editSurvey = 'surveyWrapUpPage_editSurvey',
  surveyWrapUpPage_customerVisitInsights = 'surveyWrapUpPage_customerVisitInsights',
  surveyWrapUpPage_customerVisitInsightsDescription = 'surveyWrapUpPage_customerVisitInsightsDescription',
  surveyWrapUpPage_saveAsDraft = 'surveyWrapUpPage_saveAsDraft',
  surveyWrapUpPage_submit = 'surveyWrapUpPage_submit',
  surveyWrapUpPage_offlineWarning = 'surveyWrapUpPage_offlineWarning',
  surveyWrapUpPage_submitted = 'surveyWrapUpPage_submitted',
  surveyWrapUpPage_customerRequiredTitle = 'surveyWrapUpPage_customerRequiredTitle',
  surveyWrapUpPage_customerRequiredDescription = 'surveyWrapUpPage_customerRequiredDescription',
  surveyWrapUpPage_customerRequiredButton = 'surveyWrapUpPage_customerRequiredButton',
  audio_recording = 'audio_recording',
  audio_recordingName = 'audio_recordingName',
  audio_error_mediaDeviceAPIMissing = 'audio_error_mediaDeviceAPIMissing',
  audio_error_mediaDeviceNotFound = 'audio_error_mediaDeviceNotFound',
  audio_error_notAllowed = 'audio_error_notAllowed',
  audio_error_saveError = 'audio_error_saveError',
  audio_error_unknown = 'audio_error_unknown',
  audio_playerError = 'audio_playerError',
  audio_deleteConfirmTitle = 'audio_deleteConfirmTitle',
  audio_deleteConfirmText1 = 'audio_deleteConfirmText1',
  audio_deleteConfirmText2 = 'audio_deleteConfirmText2',
  images_images = 'images_images',
  images_noImages = 'images_noImages',
  images_add = 'images_add',
  images_error = 'images_error',
  images_video_add = 'images_video_add',
  images_video_recording = 'images_video_recording',
  images_video_error_mediaDeviceAPIMissing = 'images_video_error_mediaDeviceAPIMissing',
  images_video_error_mediaDeviceNotFound = 'images_video_error_mediaDeviceNotFound',
  images_video_error_notAllowed = 'images_video_error_notAllowed',
  images_video_error_saveError = 'images_video_error_saveError',
  images_video_error_unknown = 'images_video_error_unknown',
  images_video_playerError = 'images_video_playerError'
}

export type Translations = {
  [TranslationsKeys.common_search]: string;
  [TranslationsKeys.common_surveyStatus_completed]: string;
  [TranslationsKeys.common_surveyStatus_inProgress]: string;
  [TranslationsKeys.common_surveyStatus_draft]: string;
  [TranslationsKeys.common_surveyStatus_notStarted]: string;
  [TranslationsKeys.common_surveyStatus_skipped]: string;
  [TranslationsKeys.common_customer]: string;
  [TranslationsKeys.common_country]: string;
  [TranslationsKeys.common_address]: string;
  [TranslationsKeys.common_sector]: string;
  [TranslationsKeys.common_business]: string;
  [TranslationsKeys.common_businessArea]: string;
  [TranslationsKeys.common_plannedVisit]: string;
  [TranslationsKeys.common_contact]: string;
  [TranslationsKeys.common_customerNumberAbbreviated]: string;
  [TranslationsKeys.common_survey]: string;
  [TranslationsKeys.common_cancel]: string;
  [TranslationsKeys.common_all]: string;
  [TranslationsKeys.common_results]: string;
  [TranslationsKeys.common_delete]: string;
  [TranslationsKeys.common_close]: string;
  [TranslationsKeys.common_yes]: string;
  [TranslationsKeys.common_no]: string;
  [TranslationsKeys.common_noCustomer]: string;
  [TranslationsKeys.common_loadingError]: string;
  [TranslationsKeys.common_savingError]: string;
  [TranslationsKeys.common_select]: string;
  [TranslationsKeys.common_edit]: string;
  [TranslationsKeys.common_view]: string;
  [TranslationsKeys.common_showMore]: string;
  [TranslationsKeys.common_showLess]: string;
  [TranslationsKeys.common_filters]: string;
  [TranslationsKeys.common_clearAll]: string;
  [TranslationsKeys.common_version]: string;
  [TranslationsKeys.common_addNew]: string;
  [TranslationsKeys.error500_title]: string;
  [TranslationsKeys.error500_text]: string;
  [TranslationsKeys.error500_back]: string;
  [TranslationsKeys.mainNavigationAriaLabel]: string;
  [TranslationsKeys.expandNavigationAriaLabel]: string;
  [TranslationsKeys.collapseNavigationAriaLabel]: string;
  [TranslationsKeys.expandUserMenuAriaLabel]: string;
  [TranslationsKeys.collapseUserMenuAriaLabel]: string;
  [TranslationsKeys.authenticationContext_error]: string;
  [TranslationsKeys.userMenu_online]: string;
  [TranslationsKeys.userMenu_offline]: string;
  [TranslationsKeys.userMenu_onlineDescription]: string;
  [TranslationsKeys.userMenu_offlineDescription]: string;
  [TranslationsKeys.userMenu_lastOnline]: string;
  [TranslationsKeys.mainNavigationLinksLabel]: string;
  [TranslationsKeys.navigationLinks_mySurveys]: string;
  [TranslationsKeys.navigationLinks_startNewSurvey]: string;
  [TranslationsKeys.navigationLinks_logoutUser]: string;
  [TranslationsKeys.surveyStepper_step_intro]: string;
  [TranslationsKeys.surveyStepper_step_survey]: string;
  [TranslationsKeys.surveyStepper_step_wrapUp]: string;
  [TranslationsKeys.loginPage_title]: string;
  [TranslationsKeys.loginPage_description]: string;
  [TranslationsKeys.loginPage_buttonText]: string;
  [TranslationsKeys.loginPage_buttonLoadingText]: string;
  [TranslationsKeys.loginPage_offlineErrorTitle]: string;
  [TranslationsKeys.loginPage_offlineErrorDescription]: string;
  [TranslationsKeys.mySurveysPage_myVisits_title]: string;
  [TranslationsKeys.mySurveysPage_inProgressVisits_title]: string;
  [TranslationsKeys.mySurveysPage_completedVisits_title]: string;
  [TranslationsKeys.mySurveysPage_tabs_plannedVisits]: string;
  [TranslationsKeys.mySurveysPage_tabs_inProgressVisits]: string;
  [TranslationsKeys.mySurveysPage_tabs_completedVisits]: string;
  [TranslationsKeys.mySurveysPage_info_plannedVisits]: string;
  [TranslationsKeys.mySurveysPage_search_filtersToggle]: string;
  [TranslationsKeys.mySurveysPage_search_filters_myUpcomingVisits]: string;
  [TranslationsKeys.mySurveysPage_search_filters_myOpenVisits]: string;
  [TranslationsKeys.mySurveysPage_search_filters_myVisitsToday]: string;
  [TranslationsKeys.mySurveysPage_search_filters_myVisitsTomorrow]: string;
  [TranslationsKeys.mySurveysPage_search_filters_myVisitsThisWeek]: string;
  [TranslationsKeys.mySurveysPage_search_filters_myVisitsThisMonth]: string;
  [TranslationsKeys.mySurveysPage_noSurveys]: string;
  [TranslationsKeys.mySurveysPage_noSearchResults]: string;
  [TranslationsKeys.mySurveysPage_newSurveyButtonText]: string;
  [TranslationsKeys.mySurveysPage_newSurveyWithoutCustomer]: string;
  [TranslationsKeys.mySurveysPage_showVisits]: string;
  [TranslationsKeys.mySurveysPage_overdue]: string;
  [TranslationsKeys.mySurveysPage_error]: string;
  [TranslationsKeys.surveyIntroPage_title]: string;
  [TranslationsKeys.surveyIntroPage_openCustomerSelectionAriaLabel]: string;
  [TranslationsKeys.surveyIntroPage_openSurveyTemplateSelectionAriaLabel]: string;
  [TranslationsKeys.surveyIntroPage_selectCustomerHeading]: string;
  [TranslationsKeys.surveyIntroPage_selectCustomerMessageBarTitle]: string;
  [TranslationsKeys.surveyIntroPage_selectCustomerMessageBarDescription]: string;
  [TranslationsKeys.surveyIntroPage_selectSurveyTemplateHeading]: string;
  [TranslationsKeys.surveyIntroPage_noCustomerText]: string;
  [TranslationsKeys.surveyIntroPage_noCustomerConfirmationTitle]: string;
  [TranslationsKeys.surveyIntroPage_noCustomerConfirmationDescription]: string;
  [TranslationsKeys.surveyIntroPage_noCustomerConfirmationContinueButtonText]: string;
  [TranslationsKeys.surveyIntroPage_noCustomerConfirmationAddCustomerButtonText]: string;
  [TranslationsKeys.surveyIntroPage_customerVisit_participants]: string;
  [TranslationsKeys.surveyIntroPage_customerVisit_visitType]: string;
  [TranslationsKeys.surveyPage_loadingError]: string;
  [TranslationsKeys.surveyPage_closeAndContinueLater]: string;
  [TranslationsKeys.surveyPage_deleteSurvey]: string;
  [TranslationsKeys.surveyPage_sectionSkipped]: string;
  [TranslationsKeys.surveyPage_continue]: string;
  [TranslationsKeys.surveyPage_deleteSurveyConfirmTitle]: string;
  [TranslationsKeys.surveyPage_deleteSurveyConfirmText1]: string;
  [TranslationsKeys.surveyPage_deleteSurveyConfirmText2]: string;
  [TranslationsKeys.surveySectionPage_skipSection]: string;
  [TranslationsKeys.surveySectionPage_close]: string;
  [TranslationsKeys.surveySectionPage_numericInputDescription]: string;
  [TranslationsKeys.surveySectionPage_skipSectionTitle]: string;
  [TranslationsKeys.surveySectionPage_skipSectionDescription]: string;
  [TranslationsKeys.surveySectionPage_skipSectionNotRelevant]: string;
  [TranslationsKeys.surveySectionPage_skipSectionNotObserved]: string;
  [TranslationsKeys.surveySectionPage_skipSectionOther]: string;
  [TranslationsKeys.surveySectionPage_productsInUse]: string;
  [TranslationsKeys.surveySectionPage_addProduct]: string;
  [TranslationsKeys.surveySectionPage_updateProduct]: string;
  [TranslationsKeys.surveySectionPage_detailedDescription]: string;
  [TranslationsKeys.surveySectionPage_deleteProduct]: string;
  [TranslationsKeys.surveySectionPage_deleteProductConfirm]: string;
  [TranslationsKeys.surveyWrapUpPage_editSurvey]: string;
  [TranslationsKeys.surveyWrapUpPage_customerVisitInsights]: string;
  [TranslationsKeys.surveyWrapUpPage_customerVisitInsightsDescription]: string;
  [TranslationsKeys.surveyWrapUpPage_saveAsDraft]: string;
  [TranslationsKeys.surveyWrapUpPage_submit]: string;
  [TranslationsKeys.surveyWrapUpPage_offlineWarning]: string;
  [TranslationsKeys.surveyWrapUpPage_submitted]: string;
  [TranslationsKeys.surveyWrapUpPage_customerRequiredTitle]: string;
  [TranslationsKeys.surveyWrapUpPage_customerRequiredDescription]: string;
  [TranslationsKeys.surveyWrapUpPage_customerRequiredButton]: string;
  [TranslationsKeys.audio_recording]: string;
  [TranslationsKeys.audio_recordingName]: string;
  [TranslationsKeys.audio_error_mediaDeviceAPIMissing]: string;
  [TranslationsKeys.audio_error_mediaDeviceNotFound]: string;
  [TranslationsKeys.audio_error_notAllowed]: string;
  [TranslationsKeys.audio_error_saveError]: string;
  [TranslationsKeys.audio_error_unknown]: string;
  [TranslationsKeys.audio_playerError]: string;
  [TranslationsKeys.audio_deleteConfirmTitle]: string;
  [TranslationsKeys.audio_deleteConfirmText1]: string;
  [TranslationsKeys.audio_deleteConfirmText2]: string;
  [TranslationsKeys.images_images]: string;
  [TranslationsKeys.images_noImages]: string;
  [TranslationsKeys.images_add]: string;
  [TranslationsKeys.images_error]: string;
  [TranslationsKeys.images_video_add]: string;
  [TranslationsKeys.images_video_recording]: string;
  [TranslationsKeys.images_video_error_mediaDeviceAPIMissing]: string;
  [TranslationsKeys.images_video_error_mediaDeviceNotFound]: string;
  [TranslationsKeys.images_video_error_notAllowed]: string;
  [TranslationsKeys.images_video_error_saveError]: string;
  [TranslationsKeys.images_video_error_unknown]: string;
  [TranslationsKeys.images_video_playerError]: string;
};
